/* eslint-disable camelcase */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Dimmer,
  Label,
} from 'semantic-ui-react';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import LoadImage from './LoadImage';

class MediaItem extends Component {
  static propTypes = {
    media: PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      data: PropTypes.shape({
        html: PropTypes.node,
      }),
    }),
    labelNode: PropTypes.node,
    buttonNode: PropTypes.node,
    onViewLarge: PropTypes.func,
    onRemove: PropTypes.func,
    size: PropTypes.string,
    fixedSize: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultProps = {
    fixedSize: null,
  }
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }
  getThumbnailUrl = (media) => {
    if (media && media.data && media.data.thumbnail_url) {
      return media.data.thumbnail_url;
    }
    return '';
  }
  handleShowDimmed = () => {
    this.setState({ active: true });
  }
  handleHideDimmed = () => {
    this.setState({ active: false });
  }
  render() {
    const { t } = this.props;
    const { active } = this.state;
    const thumbnailUrl = this.getThumbnailUrl(this.props.media);
    return (
      <Card className={this.props.fixedSize ? 'picture-item-fixed-size' : 'picture-item'}>
        <Dimmer.Dimmable
          dimmed={active}
          className="center"
          onMouseEnter={() => this.handleShowDimmed()}
          onMouseLeave={this.handleHideDimmed}
        >
          <Dimmer style={{ zIndex: 20 }} active={active}>
            {
              this.props.onViewLarge ?
                <Button
                  primary
                  icon="zoom"
                  content={t('View', { ns: TRANSLATION_FILES.translation })}
                  onClick={e => this.props.onViewLarge(e)}
                />
              : null
            }
            {
              this.props.onRemove ?
                <Label
                  as="a"
                  corner
                  color="red"
                  icon="close"
                  onClick={e => this.props.onRemove(e)}
                />
              : null
            }
          </Dimmer>
          <LoadImage
            centered
            asBackground={this.props.fixedSize}
            size={this.props.size}
            src={thumbnailUrl}
            labelNode={this.props.labelNode}
            isVideo
          />
        </Dimmer.Dimmable>
        <Card.Content>
          {this.props.media ? this.props.media.label : '-'}
        </Card.Content>
        {this.props.buttonNode}
      </Card>
    );
  }
}

export default withTranslation(namespaces)(MediaItem);



// WEBPACK FOOTER //
// ./src/components/MediaItem.jsx